import React from 'react';

export default function FieldDropdownViewInImport(customField, props) {
    return (
        <React.Fragment>
            {_.map(props.value, id=>
                <div key={id} className="ui5-pill-22 gray m-r-5">
                    {customField.getValueById(id)}
                </div>
            )}
        </React.Fragment>
    );
}